export default function objectsService($http, RESOURCES) {
  var areasUrl = '/areas',
    objectsUrl = '/objects';

  function getObjects(merchantId, areaId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + areasUrl + '/' + areaId + objectsUrl);
  }

  function addObject(merchantId, areaId, data) {
    return $http.post(RESOURCES.MERCHANT + '/' + merchantId + areasUrl + '/' + areaId + objectsUrl, data);
  }

  function updateObject(merchantId, areaId, objectId, data) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + areasUrl + '/' + areaId + objectsUrl + '/' + objectId, data);
  }

  function updateObjects(merchantId, areaId, data) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + areasUrl + '/' + areaId + objectsUrl, data);
  }

  function deleteObject(merchantId, areaId, objectId) {
    return $http.delete(RESOURCES.MERCHANT + '/' + merchantId + areasUrl + '/' + areaId + objectsUrl + '/' + objectId);
  }

  function deleteObjects(merchantId, areaId, selectedObjectIds) {
    var params = {
      params: {
        objectsIds: selectedObjectIds,
      },
    };
    return $http.delete(RESOURCES.MERCHANT + '/' + merchantId + areasUrl + '/' + areaId + objectsUrl, params);
  }

  function getObjectTypes() {
    return $http.get(RESOURCES.OBJECT_TYPES);
  }

  function blockTables(merchantId, data) {
    return $http.post(`${RESOURCES.MERCHANT}/${merchantId}/table-blocking`, data);
  }

  function unblockTables(merchantId, data) {
    return $http.post(`${RESOURCES.MERCHANT}/${merchantId}/table-blocking/delete`, data);
  }

  return {
    getObjects,
    addObject,
    updateObject,
    updateObjects,
    deleteObject,
    deleteObjects,
    getObjectTypes,
    blockTables,
    unblockTables,
  };
}



// WEBPACK FOOTER //
// ./src/app/merchants/areas/objects.service.js